import React, {useEffect, useState} from 'react'
import {
    BrowserRouter as Router,
    Route,
    Switch,
    useRouteMatch,
} from 'react-router-dom'
import MainWrapper from '../Components/Main/MainWrapper'
import Sidebar from '../Components/Main/Sidebar/Sidebar'
import BrowserUpdateBanner from '../Components/Main/BrowserUpdateBanner'
import Welcome from '../Components/Main/Welcome'
import Lesson from './Main/Lesson'
import {useStripe, useElements} from '@stripe/react-stripe-js';
import api from '../../util/api'

const Main = () => {

    const [lessons, setLessons] = useState(null)
    const [dateString, ] = useState(null)
    const [isInstructor, setIsInstructor] = useState(false)
    const [loggedInUser, setLoggedInUser] = useState(null)
    const [isSessionModalOpen, setIsSessionModalOpen] = useState(null)
    const [deleteSessionId, setDeleteSessionId] = useState(null);
    const [deletedSession, setDeletedSession] = useState(null);
    const {path} = useRouteMatch();

    const stripe = useStripe();
    const elements = useElements();

    const openSessionModal = function () {
        setIsSessionModalOpen(true);
    };

    const closeSessionModal = function () {
        setIsSessionModalOpen(false);
    };

    const openDeleteSessionModal = function (uuid) {
        setDeleteSessionId(uuid);
        api().get('/sessions/' + uuid)
            .then((response) => {
                setDeletedSession(response.data.data);
            });
    };

    const closeDeleteSessionModal = function () {
        setDeleteSessionId(null);
        setDeletedSession(null);
    };

    const fetchLessons = async function (start_date = null) {
        if (start_date) {
            const resp = await fetch(`/api/sessions?start_date=` + start_date);
            setLessons((await resp.json()).data);
        } else {
            const resp = await fetch(`/api/sessions`);
            setLessons((await resp.json()).data);
        }
    };

    const getUser = async function () {
        api().get('/user')
            .then((response) => {
                setIsInstructor(response.data.is_instructor)
                setLoggedInUser(response.data)
            });
    };

    useEffect(() => {
        getUser();
        fetchLessons();
    }, []);

    return (
            <MainWrapper className="main-wrapper">
                <BrowserUpdateBanner/>
                <Router>
                    <Switch>
                        <Route path={'/lesson/:id'}>
                            <Lesson isInstructor={isInstructor}/>
                        </Route>
                        <Route exact path={path}>
                            <Sidebar stripe={stripe} elements={elements}
                                     loggedInUser={loggedInUser}
                                     deleteSessionId={deleteSessionId}
                                     deletedSession={deletedSession}
                                     isInstructor={isInstructor}
                                     fetchLessons={() => {fetchLessons()}} isSessionModalOpen={isSessionModalOpen}
                                     closeSessionModal={() => {closeSessionModal()}}
                                     closeDeleteSessionModal={() => {closeDeleteSessionModal()}}

                            />
                            <Welcome dateString={dateString} fetchLessons={(val) => {fetchLessons(val)}}
                                     loggedInUser={loggedInUser}
                                     openSessionModal={() => {openSessionModal()}}
                                     openDeleteSessionModal={(id) => {openDeleteSessionModal(id)}} lessons={lessons}
                                     isInstructor={isInstructor}/>
                        </Route>
                    </Switch>
                </Router>
            </MainWrapper>
    )
};

export default Main
